import { BASE_URL } from './../utils/helpers'

export const CHARACTERS_REQUEST = 'CHARACTERS_REQUEST';
export const CHARACTERS_SUCCESS = 'CHARACTERS_SUCCESS';
export const CHARACTERS_FAILED = 'CHARACTERS_FAILED';

export const getCharacters = (requestUrl='start') => async dispatch => {
  dispatch({ type: CHARACTERS_REQUEST });
  try {
    const currentApiUrl = requestUrl === 'start' ? BASE_URL + 'character/' : requestUrl;

    const response = await fetch(currentApiUrl);
    const characters = await response.json();

    dispatch({ 
      type: CHARACTERS_SUCCESS, 
      payload: {
        characters,
      },
    });
  } catch (error) {
    dispatch({ type: CHARACTERS_FAILED, payload: error });
  }
};